export enum CaseStatus {
  AIAnalysingError = 0,
  Open = 1,
  AIAnalysing = 2,
  AIAnalysingComplete = 3,
  WaitingConsultation = 4,
  ReportSent = 5,
  Closed = 6,
}
